export default __webpack_public_path__ + "static/media/arrows.4d642df7.svg";